/* eslint-disable */
import { updateOrder, UpdateOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/CancelOrder";
import { callCancelOrderWithResult } from "@auer-steel/Services/OrderCancelService";

addToChainAfter(chain, PopulateApiParameter, async function (props) {
    const response = await callCancelOrderWithResult(props.apiParameter.order.erpOrderNumber);
});
